import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPrint = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M5.87 1.039A3.547 3.547 0 0 1 8.376 0h7.246a3.547 3.547 0 0 1 3.547 3.547v3.698h1.283A3.547 3.547 0 0 1 24 10.792v4.83a3.547 3.547 0 0 1-3.547 3.548H19.17v1.283A3.547 3.547 0 0 1 15.623 24H8.377a3.547 3.547 0 0 1-3.547-3.547V19.17H3.547A3.547 3.547 0 0 1 0 15.623v-4.83a3.547 3.547 0 0 1 3.547-3.548H4.83V3.547c0-.94.374-1.843 1.04-2.508ZM7.093 18.04v-2.417c0-.709.575-1.283 1.283-1.283h7.246c.708 0 1.283.574 1.283 1.283v4.83c0 .708-.575 1.283-1.283 1.283H8.377a1.283 1.283 0 0 1-1.283-1.283V18.04ZM4.83 16.906H3.547a1.283 1.283 0 0 1-1.283-1.283v-4.83a1.283 1.283 0 0 1 1.283-1.284h16.906a1.283 1.283 0 0 1 1.283 1.283v4.83a1.283 1.283 0 0 1-1.283 1.284H19.17v-1.283a3.547 3.547 0 0 0-3.547-3.547H8.377a3.547 3.547 0 0 0-3.547 3.547v1.283ZM16.906 3.547v3.698H7.094V3.547a1.283 1.283 0 0 1 1.283-1.283h7.246a1.283 1.283 0 0 1 1.283 1.283Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPrint);
export default ForwardRef;
